import { graphql } from '@/__generated__';
import { useQueryStable } from '../useQueryStable';

export const GetModelQueryHistoryState = graphql(/* GraphQL */ `
  query ModelQueryHistoryState($environmentId: BigInt!) {
    environment(id: $environmentId) {
      modelQueryHistoryState {
        state
        lastUpdatedAt
        error
        errorCategory
      }
      adapterType
    }
  }
`);

type ModelQueryHistoryStateParams = {
  environmentId: number | undefined;
  pause?: boolean;
};

export const useModelQueryHistoryState = ({
  environmentId = 0,
  pause,
}: ModelQueryHistoryStateParams) => {
  const query = useQueryStable({
    query: GetModelQueryHistoryState,
    variables: { environmentId },
    pause: pause || !environmentId,
  });

  return query;
};
